import * as React from "react";
import * as _ from "underscore";
import { connect } from "react-redux";

import { AppShape, HurdleShape } from "@eave/shared/types/api";
import APIClient from "../../APIClient";
import { loadApp } from "../actions";

import CQMHurdleModal from "../shared/CQMHurdleModal";
import CQMCheckSections from "../shared/CQMCheckSections";

require(`../../../assets/stylesheets/components/underwriter_dashboard/hurdle_editors/\
cqm_info_review.scss`);

interface CQMBasicInfoReviewProps {
  dispatch: Function;
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
}

// TODO: jjw: quite similar to CQMMiscInfoReview; should make CQMInfoReview
// parent class and then subclass into CQMBasicInfoReview & CQMMiscInfoReview

class CQMBasicInfoReview extends React.Component<CQMBasicInfoReviewProps, any> {
  constructor(props) {
    super(props);
    this.state = {
      checks: null,
      changesMade: false,
    };
  }

  componentDidMount() {
    this.populateChecks(this.props.app);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.app.id !== this.props.app.id) {
      this.populateChecks(nextProps.app);
    }
  }

  static mergeChecksIntoDefs(checkDefs, checks) {
    return _.map(checkDefs, (checkDef: any) => {
      const chk: any = _.where(checks, {
        hurdle_name: "CQMBasicInfoReviewHurdle",
        check_name: checkDef.name,
      });
      return {
        ...checkDef,
        ok: chk.length > 0 ? chk[0].ok : false,
      };
    });
  }

  populateChecks(app) {
    APIClient.get(`/loan_applications/${app.id}/hurdles/cqm_basic_info_review/check_defs`).then(
      (resp: any) => {
        this.setState({
          ...this.state,
          checks: CQMBasicInfoReview.mergeChecksIntoDefs(resp.checkDefs, app.cqm_checks),
        });
      },
    );
  }

  onSave() {
    const { dispatch, app, onHide } = this.props;

    APIClient.put(
      `/loan_applications/${app.id}/hurdles/cqm_basic_info_review/sync_checks`,
      this.state.checks,
    ).then(() => {
      loadApp(dispatch, app.id);
      onHide();
    });
  }

  onToggle(checkName) {
    const updated = _.map(this.state.checks, (chk: any) => {
      if (chk.name === checkName) {
        return {
          ...chk,
          ok: !chk.ok,
        };
      }
      return chk;
    });

    this.setState({
      ...this.state,
      checks: updated,
      changesMade: true,
    });
  }

  render() {
    const { checks, changesMade } = this.state;

    return (
      <CQMHurdleModal {...this.props} changesMade={changesMade} onSave={this.onSave.bind(this)}>
        {checks && <CQMCheckSections checks={checks} onToggle={this.onToggle.bind(this)} />}
      </CQMHurdleModal>
    );
  }
}

export default connect()(CQMBasicInfoReview);
